<template>
  <!-- 此模块为票数详情解释说明弹框 -->
  <div class="votes-detail">
    <van-popup v-model="showDialog">
      <div class="content">
        <div class="header flex">
          <div class="title">票数详情</div>
          <div class="close" @click="showDialog=false">
            <img src="../../assets/images/hisTrack/clear.png" alt="" srcset="">
          </div>
        </div>
        <div class="detail flex">
          <div class="votes-box flex1">
            <div class="back-piao">票</div>
            <div>{{ticketTotal}}</div>
          </div>
          <div class="votes-box flex1 sign">=</div>
          <div class="votes-box flex1">
            <div class="back-mian">{{ filterIsRecharge ? '免' : '体' }}</div>
            <!-- <div class="back-mian" v-if="(isIos && isWechart) || isQQ">体</div> -->
            <div>{{freeTicket}}</div>
          </div>
           <div class="votes-box flex1 sign">+</div>
           <div class="votes-box flex1">
            <!-- <div class="back-chong"
              v-if="(isAndroid && isWechart) || (isIos && !isWechart && !isQQ)"
            >充</div>
            <div class="back-chong" v-if="(isIos && isWechart)  || isQQ">正</div> -->
            <div class="back-chong">{{ filterIsRecharge ? '充' : '正' }}</div>
            <div>{{rechargeTicket}}</div>
          </div>
        </div>
        <div class="introduce">
          <div class="votes-box flex">
            <div class="back-piao">票</div>
            <div class="title">票的定义</div>
          </div>
          <div class="votes-box-detail">
            1票 = 当天内可重复定位1辆货车位置（24点前）
          </div>
          <div class="votes-box flex">
            <!-- <div class="back-mian" v-if="(isAndroid && isWechart) || (isIos && !isWechart && !isQQ)">免</div>
            <div class="back-mian" v-if="(isIos && isWechart)  || isQQ">体</div> -->
            <div class="back-mian" >{{ filterIsRecharge ? '免' : '体' }}</div>
            <!-- <div class="title" v-if="(isAndroid && isWechart) || (isIos && !isWechart && !isQQ)">免费票</div>
            <div class="title"  v-if="(isIos && isWechart) || isQQ">体验票</div> -->
            <div class="title">{{ filterIsRecharge ? '免费票' : '体验票' }}</div>
          </div>
          <div class="votes-box-detail">
            我们每月向用户赠送一定体验票数，只限当月使用。
          </div>
          <div class="votes-box flex">
            <!-- <div class="back-chong" v-if="(isIos && isWechart) || isQQ">正</div>
            <div class="back-chong"
              v-if="(isAndroid && isWechart) ||(isIos && !isWechart && !isQQ)"
            >充</div> -->
            <div class="back-chong">{{ filterIsRecharge ? '充' : '正' }}</div>
            <!-- <div class="title" v-if="(isIos && isWechart) || isQQ">正式票</div>
            <div class="title" v-if="(isAndroid && isWechart) || (isIos && !isWechart && !isQQ)">充值票</div> -->
            <div class="title">{{ filterIsRecharge ? '充值票' : '正式票' }}</div>
          </div>
          <div class="votes-box-detail">
            {{ rechargeMessage }}
          </div>
          <div class="votes-box flex">
            <div class="back-xu">序</div>
            <div class="title">扣票顺序</div>
          </div>
          <div class="votes-box-detail">
            付费用户将优先扣除免费票。未查询到数据结果，不扣除票数。
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    tipType: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    ...mapGetters(['ticketTotal', 'freeTicket', 'rechargeTicket']),
    rechargeMessage () {
      if (this.isQQ || this.isBytedance) {
        return '如果免费票不够用，您可以下载App购买充值票，充值票购买后不会过期。'
      }
      if (this.isWechart) {
        return this.isIos ? '体验票用完需消耗正式票，正式票1年有效' : '如果免费票不够用，您可以在商城购买充值票，充值票购买日起1年内有效，可长期使用。'
      } else {
        if (this.isIos && this.tipType === 1) {
          return '如果免费票不够用，您可以在商城购买充值票，充值票购买后不会过期。'
        } else {
          return '如果免费票不够用，您可以在商城购买充值票，充值票购买日起1年内有效，可长期使用。'
        }
      }
    },
    /**
     *
     *
     * 过滤是否可以充值来展示相关字段
    */
    filterIsRecharge () {
      if (this.isIosApp || (this.isAndroid && this.isWechart)) {
        return true
      } else {
        return false
      }
    },
  },
  created () {},
  mounted () {},
  watch: {},
  methods: {
    /**
     * 显示票数详情弹框
    */
    showPopup () {
      this.showDialog = true
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.votes-detail>:first-child {
  background-color: rgba(0,0,0,.4)
}
.votes-detail>:nth-child(2) {
  border-radius: 12px;
  width: 80%;
}
.votes-detail {
  .flex {
    display: flex;
  }
  .content {
    padding: 10px 20px;
    background-color: #ffffff;
    .header {
      justify-content: center;
      padding-bottom: 30px;
      padding-top: 20px;
      align-items: center;
      .title {
        font-size: 26px;
        margin: 0 auto;
        text-align: center;
        padding-left: 26px;
      }
      .close {
        width: 32px;
        height: 32px;
        img {
          width: 100%;
        }
      }
    }
    .detail {
      padding-bottom: 20px;
      border-bottom: 1px solid #e5e5e5;
      margin: 0px 4px;
      .votes-box {
        text-align: center;
        font-size: 24px;
        margin: 2px 0px;
        color: #282828;
        :first-child {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          text-align: center;
          line-height: 32px;
          padding: 6px;
          margin: 0 auto;
          color: #ffffff;
          margin-bottom: 10px;
        }
      }
    }
    .introduce {
      color: #656565;
      .votes-box {
        align-items: center;
        margin: 16px 0;
        .title {
          padding-left: 20px;
          font-size: 24px;
          color: #282828;
        }
      }
      .votes-box>:first-child {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        text-align: center;
        line-height: 32px;
        font-size: 20px;
        padding: 6px;
        color: #ffffff;
      }
      .votes-box-detail {
        font-size: 24px;
        padding-bottom: 10px;
      }
    }
    .sign {
      font-size: 40px;
      padding-bottom: 30px;
    }
    .back-piao {
      background-color: #F8B81E;
    }
    .back-mian {
      background-color: #FF4552;
    }
    .back-chong {
      background-color: #5572FD;
    }
    .back-xu {
      background-color: #1BD039;
    }
  }
  .flex1 {
    flex: 1;
  }
}
</style>
